import TokenTags from "./TokenTags";

export default TokenTags;
